import { createContext, useContext, useEffect } from 'react';
interface ThemeColorProviderProps {
  color?: string;
  children: React.ReactNode;
}

const ThemeColorContext = createContext<string | undefined>(undefined);

function darken(hex: string, amount = 0.1): string {
  let [r, g, b] = hex
    .replace('#', '')
    .match(/.{2}/g)!
    .map((x) => Math.round(parseInt(x, 16) * (1 - amount)));
  return `#${[r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')}`;
}

export const ThemeColorProvider: React.FC<ThemeColorProviderProps> = ({
  color = '#6366f1',
  children
}) => {
  useEffect(() => {
    if (color) {
      document.documentElement.style.setProperty('--primary-color', color);
      document.documentElement.style.setProperty(
        '--primary-hover',
        darken(color)
      );
    }
  }, [color]);

  return (
    <ThemeColorContext.Provider value={color}>
      {children}
    </ThemeColorContext.Provider>
  );
};

export const useThemeColor = () => useContext(ThemeColorContext);
